export default [
  /**
   *  PENELITIAN DAN PENGABDIAN INTERNAL
   */
  {
    path: "/lppm/penelitian-pengabdian-internal",
    name: "lppm-penelitian-pengabdian-internal",
    component: () =>
      import("../../views/rektorat/lppm/PenelitianPengabdianInternal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Penelitian & Pengabdian Internal", active: true },
      ],
      pageTitle: "Penelitian & Pengabdian Internal",
    },
  },
  /**
   *  PENELITIAN DAN PENGABDIAN MANDIRI
   */
  {
    path: "/lppm/penelitian-pengabdian-mandiri",
    name: "lppm-penelitian-pengabdian-mandiri",
    component: () =>
      import("../../views/rektorat/lppm/PenelitianPengabdianMandiri.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Penelitian & Pengabdian Mandiri", active: true },
      ],
      pageTitle: "Penelitian & Pengabdian Mandiri",
    },
  },
  /**
   *  PUBLIKASI DOSEN
   */
  {
    path: "/lppm/publikasi-dosen",
    name: "lppm-publikasi-dosen",
    component: () =>
      import("../../views/rektorat/lppm/publikasi-dosen/PublikasiDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Publikasi Dosen", active: true },
      ],
      pageTitle: "Publikasi Dosen",
    },
  },

  /**
   *   LAPORAN PENGABDIAN
   */
  {
    path: "/lppm/laporan-pengabdian",
    name: "lppm-laporan-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/laporan-pengabdian/LaporanPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Laporan Pengabdian", active: true },
      ],
      pageTitle: "Laporan Pengabdian",
    },
  },
  {
    path: "/lppm/laporan-pengabdian/detail/:idPengabdian",
    name: "lppm-laporan-pengabdian-detail",
    component: () =>
      import("../../views/rektorat/lppm/laporan-pengabdian/DetailLaporan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Laporan Pengabdian", url: "/lppm/laporan-pengabdian" },
        { title: "Detail Laporan", active: true },
      ],
      pageTitle: "Detail Laporan",
    },
  },
  {
    path: "/lppm/grup-riset",
    name: "lppm-grup-riset",
    component: () =>
      import("../../views/rektorat/lppm/grup-riset/LihatGrupRiset.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Grup Riset", active: true },
      ],
      pageTitle: "Grup Riset",
    },
  },
  {
    path: "/lppm/grup-riset/tambah",
    name: "lppm-grup-riset-tambah",
    component: () =>
      import("../../views/rektorat/lppm/grup-riset/TambahGrupRiset.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Tambah Grup Riset", active: true },
      ],
      pageTitle: "Tambah Grup Riset",
    },
  },
  /**
   *   LAPORAN PENELITIAN
   */
  {
    path: "/lppm/laporan-penelitian",
    name: "lppm-laporan-penelitian",
    component: () =>
      import(
        "../../views/rektorat/lppm/laporan-penelitian/LaporanPenelitian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Laporan Penelitian", active: true },
      ],
      pageTitle: "Laporan Penelitian",
    },
  },

  {
    path: "/lppm/laporan-penelitian/detail/:idPenelitian",
    name: "lppm-laporan-penelitian-detail",
    component: () =>
      import("../../views/rektorat/lppm/laporan-penelitian/DetailLaporan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Laporan Penelitian", url: "/lppm/laporan-penelitian" },
        { title: "Detail Laporan", active: true },
      ],
      pageTitle: "Detail Laporan",
    },
  },
  /**
   *   SKEMA PENGABDIAN
   */
  {
    path: "/lppm/skema-pengabdian",
    name: "lppm-skema-pengabdian",
    component: () =>
      import("../../views/rektorat/lppm/skema-pengabdian/SkemaPengabdian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Pengabdian", active: true },
      ],
      pageTitle: "Skema Pengabdian",
    },
  },
  {
    path: "/lppm/skema-pengabdian/bidang-riset/:skemaId",
    name: "lppm-skema-bidang-riset-pengabdian",
    component: () =>
      import("../../views/rektorat/lppm/skema-pengabdian/BidangRiset.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Pengabdian", url: "/lppm/skema-pengabdian" },
        { title: "Bidang Riset", active: true },
      ],
      pageTitle: "Bidang Riset",
    },
  },

  {
    path: "/lppm/skema-pengabdian/bidang-riset/bidang-kajian/:konsentrasiId",
    name: "lppm-skema-bidang-kajian-pengabdian",
    component: () =>
      import("../../views/rektorat/lppm/skema-pengabdian/BidangKajian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Pengabdian", url: "/lppm/skema-pengabdian" },
        {
          title: "Bidang Riset",
          url: "/lppm/skema-pengabdian/bidang-riset/:skemaId",
        },
        { title: "Tema Kajian", active: true },
      ],
      pageTitle: "Tema Kajian",
    },
  },
  /**
   *   SKEMA PENELITIAN
   */
  {
    path: "/lppm/skema-penelitian",
    name: "lppm-skema-penelitian",
    component: () =>
      import("../../views/rektorat/lppm/skema-penelitian/SkemaPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Penelitian", active: true },
      ],
      pageTitle: "Skema Penelitian",
    },
  },
  {
    path: "/lppm/skema-penelitian/konsentrasi-riset/:skemaId",
    name: "lppm-skema-konsentrasi-riset",
    component: () =>
      import("../../views/rektorat/lppm/skema-penelitian/KonsentrasiRiset.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Penelitian", url: "/lppm/skema-penelitian" },
        { title: "Bidang Riset", active: true },
      ],
      pageTitle: "Bidang Riset",
    },
  },
  {
    path: "/lppm/skema-penelitian/konsentrasi-riset/bidang-kajian/:konsentrasiId",
    name: "lppm-skema-bidang-kajian",
    component: () =>
      import("../../views/rektorat/lppm/skema-penelitian/BidangKajian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Skema Penelitian", url: "/lppm/skema-penelitian" },
        {
          title: "Bidang Riset",
          url: "/lppm/skema-penelitian/konsentrasi-riset/:skemaId",
        },
        { title: "Tema Kajian", active: true },
      ],
      pageTitle: "Tema Kajian",
    },
  },

  /**
   *
   *  LUARAN PENELITIAN
   */

  {
    path: "/lppm/luaran-penelitian",
    name: "lppm-luaran-penelitian",
    component: () =>
      import(
        "../../views/rektorat/lppm/luaran-penelitian/LuaranPenelitian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Luaran Penelitian", active: true },
      ],
      pageTitle: "Luaran Penelitian",
    },
  },
  /**
   *
   *  LUARAN TAMBAHAN
   */

  {
    path: "/lppm/luaran-tambahan",
    name: "lppm-luaran-tambahan",
    component: () =>
      import("../../views/rektorat/lppm/luaran-tambahan/LuaranTambahan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Luaran Tambahan", active: true },
      ],
      pageTitle: "Luaran Tambahan",
    },
  },
  /**
   *
   *  LUARAN PENGABDIAN
   */

  {
    path: "/lppm/luaran-pengabdian",
    name: "lppm-luaran-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/luaran-pengabdian/LuaranPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Luaran Pengabdian", active: true },
      ],
      pageTitle: "Luaran Pengabdian",
    },
  },

  /**
   *  SETTING PERIODE PENELITIAN & PELAKSANAAN
   */
  {
    path: "/lppm/periode-usulan-pelaksanaan",
    name: "lppm-periode-usulan-pelaksanaan",
    component: () =>
      import(
        "../../views/rektorat/lppm/periode-usulan-pelaksanaan/PeriodeUsulanPelaksanaan.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Periode Usulan & Pelaksanaan", active: true },
      ],
      pageTitle: "Periode Usulan & Pelaksanaan",
    },
  },
  /**
   * USULAN PENELITIAN DOSEN
   */
  {
    path: "/lppm/usulan-penelitian",
    name: "lppm-usulan-penelitian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-penelitian/UsulanPenelitian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Penelitian", active: true },
      ],
      pageTitle: "Usulan Penelitian",
    },
  },
  {
    path: "/lppm/usulan-penelitian/keputusan-penelitian/:penelitianId",
    name: "lppm-keputusan-penelitian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-penelitian/KeputusanPenelitian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Penelitian", url: "/lppm/usulan-penelitian" },
        { title: "Keputusan Penelitian", active: true },
      ],
      pageTitle: "Keputusan Penelitian",
    },
  },
  /**
   * USULAN PENGABDIAN DOSEN
   */
  {
    path: "/lppm/usulan-pengabdian",
    name: "lppm-usulan-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-pengabdian/UsulanPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Pengabdian", active: true },
      ],
      pageTitle: "Usulan Pengabdian",
    },
  },
  {
    path: "/lppm/usulan-pengabdian/keputusan-pengabdian/:pengabdianId",
    name: "lppm-keputusan-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-pengabdian/KeputusanPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Pengabdian", url: "/lppm/usulan-pengabdian" },
        { title: "Keputusan Pengabdian", active: true },
      ],
      pageTitle: "Keputusan Pengabdian",
    },
  },

  {
    path: "/lppm/kriteria-penilaian",
    name: "lppm-kriteria-penilaian",
    component: () =>
      import(
        "../../views/rektorat/lppm/kriteria-penilaian/KriteriaPenilaian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Kriteria Penilaian", active: true },
      ],
      pageTitle: "Kriteria Penilaian",
    },
  },
  {
    path: "/lppm/kriteria-penilaian/tambah-kriteria-penilaian",
    name: "lppm-tambah-kriteria-penilaian",
    component: () =>
      import(
        "../../views/rektorat/lppm/kriteria-penilaian/TambahKriteriaPenilaian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Kriteria Penilaian", url: "/lppm/kriteria-penilaian" },
        { title: "Tambah Kriteria Penilaian", active: true },
      ],
      pageTitle: "Tambah Kriteria Penilaian",
    },
  },
  {
    path: "/lppm/kriteria-penilaian/tambah-kriteria-penilaian-pengabdian",
    name: "lppm-tambah-kriteria-penilaian-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/kriteria-penilaian/TambahKriteriaPenilaianPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Kriteria Penilaian", url: "/lppm/kriteria-penilaian" },
        { title: "Tambah Kriteria Penilaian", active: true },
      ],
      pageTitle: "Tambah Kriteria Penilaian",
    },
  },
  {
    path: "/lppm/usulan-penelitian/sunting-usulan-penelitian/:penelitianId",
    name: "lppm-sunting-usulan-penelitian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-penelitian/SuntingUsulanPenelitian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Penelitian", url: "/lppm/usulan-penelitian" },
        { title: "Sunting Usulan Penelitian", active: true },
      ],
      pageTitle: "Sunting Usulan Penelitian",
    },
  },
  {
    path: "/lppm/usulan-pengabdian/sunting-usulan-pengabdian/:pengabdianId",
    name: "lppm-sunting-usulan-pengabdian",
    component: () =>
      import(
        "../../views/rektorat/lppm/usulan-pengabdian/SuntingUsulanPengabdian.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Usulan Pengabdian", url: "/lppm/usulan-pengabdian" },
        { title: "Sunting Usulan Pengabdian", active: true },
      ],
      pageTitle: "Sunting Usulan Pengabdian",
    },
  },

  {
    path: "/lppm/rekapitulasi",
    name: "lppm-rekapitulasi",
    component: () =>
      import("../../views/rektorat/lppm/rekapitulasi/Rekapitulasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LPPM", url: "/submenu/lppm" },
        { title: "Rekapitulasi", active: true },
      ],
      pageTitle: "Rekapitulasi",
    },
  },
];
